const PaymentStatus = {
  ON_TIME: 'ON_TIME',
  OVERDUE: 'OVERDUE',
};
export default PaymentStatus;
